import { render, staticRenderFns } from "./AuthManage.vue?vue&type=template&id=af6334aa&scoped=true&"
import script from "./AuthManage.vue?vue&type=script&lang=js&"
export * from "./AuthManage.vue?vue&type=script&lang=js&"
import style0 from "./AuthManage.vue?vue&type=style&index=0&id=af6334aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6334aa",
  null
  
)

export default component.exports